export default {
    clientId: '1d0156bae46140b0ae48139fcf3f8a6f',
    secretId: 'f09711dfe2514af49171c494eac0cca7',
    redirectUri: `${window.location.origin}${window.location.pathname}`,
};
